import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';
import makeStyles from '@material-ui/core/styles/makeStyles';
import React from 'react';
import { useLocation } from 'react-router-dom';
import routes from '../routes';
import SignInButton from './SignInButton';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(4),
    margin: theme.spacing(4),
    maxWidth: '90vw',
    marginLeft: 'auto',
    marginRight: 'auto',
    textAlign: 'center',
    '@media (min-width: 480px)': {
      maxWidth: '80vw',
    },
    '@media (min-width: 768px)': {
      maxWidth: '60vw',
    },
    '& h1': {
      marginBottom: theme.spacing(2),
    },
  },
  buttonContainer: {
    margin: theme.spacing(2),
  },
}));

export default function Login() {
  const classes = useStyles();
  const location = useLocation();
  const returnTo = (location.state as any)?.from ?? routes.home;
  return (
    <Paper className={classes.root}>
      <Typography variant="h3" component="h1">
        Sign in
      </Typography>
      <Typography>
        If you already applied before with this app,
        you can sign in to check your application progress using your GitHub account.
      </Typography>
      <Box className={classes.buttonContainer}>
        <SignInButton returnTo={returnTo} size="large" />
      </Box>
    </Paper>
  );
}
